// extracted by mini-css-extract-plugin
module.exports = {"selection-group-wrapper":"SelectionGroup_selection-group-wrapper__1EaHY"};